import { useEffect, useState } from 'react';

export interface Achievement {
  id:          string;
  title:       string;
  description: string;
  icon:        string;
  points:      number;
}

interface Props {
  achievement: Achievement;
  onClose:     () => void;
}

export function AchievementToast({ achievement, onClose }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const in_ = setTimeout(() => setVisible(true), 10);
    // Auto-close after 5s
    const out_ = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 400);
    }, 5000);
    return () => { clearTimeout(in_); clearTimeout(out_); };
  }, [onClose]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={`Conquista desbloqueada: ${achievement.title}`}
      className={`
        fixed bottom-6 right-4 z-50 max-w-sm w-full sm:w-auto
        bg-[#0D1130] border border-[#C9A84C] rounded-sm p-4 shadow-2xl
        transition-all duration-400
        ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}
      `}
    >
      <div className="flex items-start gap-4">
        <span className="text-4xl flex-shrink-0" aria-hidden="true">{achievement.icon}</span>
        <div>
          <p className="text-[#C9A84C] text-[10px] tracking-[3px] uppercase mb-1">
            Conquista desbloqueada · {achievement.points} pts
          </p>
          <h4 className="text-[#F5ECD7] font-medium">{achievement.title}</h4>
          <p className="text-[#F5ECD7]/70 text-sm mt-1">{achievement.description}</p>
        </div>
        <button
          onClick={() => { setVisible(false); setTimeout(onClose, 400); }}
          className="text-[#F5ECD7]/40 hover:text-[#F5ECD7] ml-auto flex-shrink-0 text-xs"
          aria-label="Fechar"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
